import { RouteProps } from 'react-router';
import OtmRegistrationTable from '.';
import MfSuccess from '../ExploreMFs/mf-success';
import EMandate from './EMandate';
import OTMCancelotp from './OTMCancelotp';
import OTMCancelStatus from './OTMCancelStatus';
import { EMandatePaths } from './types';

const Routes: RouteProps[] = [
    {
        path: EMandatePaths.OtmDetails,
        component: OtmRegistrationTable,
    },
    {
        path: EMandatePaths.OtmRegister,
        component: EMandate,
    },
    {
        path: EMandatePaths.OtmStatus + '/:id',
        component: MfSuccess,
    },
    {
        path: EMandatePaths.OtmCancelOTP,
        component: OTMCancelotp,
    },
    {
        path: EMandatePaths.OtmCancelStatus,
        component: OTMCancelStatus,
    },
];

export { Routes as EmandateRoutes };
